import React, { useState } from 'react';
import styles from './RankingCarHeader.module.scss';
import { SFIcon, SFText, SFTooltip } from 'sfui';
import { isMobile } from '../../../../../Helpers';
import { InteractiveBox } from 'ui-smartforce-settings';

export interface RankingCarHeaderProps {
  elements_label: string;
  value_label: string;
  info_message: string;
}

export const RankingCarHeader = ({
  elements_label,
  value_label,
  info_message
}: RankingCarHeaderProps): React.ReactElement<RankingCarHeaderProps> => {
  const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);

  const onInfoClose = () => {
    if (isMobile()) {
      setIsTooltipOpen(false);
    }
  };

  const onInfoClick = () => {
    if (isMobile() && !isTooltipOpen) {
      setIsTooltipOpen(true);
    }
  };

  return (
    <div className={styles.rankingCarHeader}>
      <div className={styles.headerElementInfo}>
        <SFText className={styles.text} type="component-2" sfColor="neutral">
          {elements_label}
        </SFText>

        <SFTooltip
          title={info_message}
          placement="bottom-start"
          open={isMobile() ? isTooltipOpen : undefined}
          onClose={onInfoClose}
          disableHoverListener={isMobile()}
          PopperProps={{ disablePortal: true, style: { zIndex: 1199 } }}
        >
          <InteractiveBox className={styles.icon} onClick={onInfoClick}>
            <SFIcon icon="Information" size={12} />
          </InteractiveBox>
        </SFTooltip>
      </div>

      <SFText className={styles.text} type="component-2" sfColor="neutral">
        {value_label}
      </SFText>
    </div>
  );
};
